// extracted by mini-css-extract-plugin
export default {"wrapper":"product-nav_wrapper__+B8mF"};